<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.questions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="mt-3 w-full flex space-x-4 justify-end">
            <AppButton element="InertiaLink" :href="meta.links.questions_per_tag_index">
                {{ $t('messages.questions_per_tag_analysis') }}
            </AppButton>
            <AppButton element="InertiaLink" :href="meta.links.question_images_index">
                {{ $tc('messages.images', 2) }}
            </AppButton>
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">{{ $t('messages.search') }}</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.search"
                            type="text"
                            :placeholder="`${$t('messages.search')}: ${$t('messages.title')}`"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <FormLabel :value="$t('messages.description')" for="description" />
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.description"
                            type="text"
                            :placeholder="`${$t('messages.search')}: ${$t('messages.description')}`"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <FormLabel :value="$t('messages.description_(not_contains)')" for="description_no" />
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.description_no"
                            type="text"
                            :placeholder="`${$t('messages.search')}: ${$t('messages.description')}`"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">{{
                        $tc('messages.tags', 1)
                    }}</label>
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.tag_name"
                            type="text"
                            name="tag_name"
                            id="tag_name"
                            list="tag_name_suggestions"
                            :placeholder="`${$t('messages.search')}: ${$tc('messages.tags', 1)}`"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                        <DataListSuggestions
                            id="tag_name_suggestions"
                            :url="meta.links.tags_search"
                            :search="form.tag_name"
                        />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="">
                        <FormLabel :value="$t('messages.difficulty')" for="difficulty_in" />
                        <SlideOverCheckboxInput v-model="form.difficulty_in" :options="options.difficulties" />
                        <FormError :value="form.errors.difficulty_in" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="">
                        <FormLabel :value="$tc('messages.subject', 2)" for="subject_id" />
                        <FormSelect
                            id="subject_id"
                            v-model="form.subject_id"
                            :options="options.subjects"
                            class="mt-1 w-full"
                            :null-option="true"
                            optgroups
                        />
                        <FormError :value="form.errors.subject_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.grade_level')" for="grade_level_id" />
                        <FormSelect
                            id="grade_level_id"
                            v-model="form.grade_level_id"
                            :options="options.grade_levels"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.grade_level_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.type')" for="type" />
                        <FormSelect
                            id="type"
                            v-model="form.type"
                            :options="options.types"
                            class="mt-1 w-full"
                            :null-option-text="$t('messages.all')"
                        />
                        <FormError :value="form.errors.type" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.order_by')" for="order_by" />
                        <FormSelect
                            id="order_by"
                            v-model="form.order_by"
                            :options="options.orders"
                            class="mt-1 w-full"
                            :null-option="false"
                        />
                        <FormError :value="form.errors.type" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2" v-if="options.tag">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.tags', 1)" />
                        <div>
                            <InertiaLink :href="options.tag.url">
                                <BadgePill>
                                    {{ options.tag.text }}
                                    <IconCircleXFilled class="ml-2 w-4 h-4 text-indigo-700 hover:text-red-700" />
                                </BadgePill>
                            </InertiaLink>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2" v-if="options.fileCollection">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.image_bank')" />
                        <div>
                            <InertiaLink :href="options.fileCollection.url">
                                <BadgePill>
                                    {{ options.fileCollection.text }}
                                    <IconCircleXFilled class="ml-2 w-4 h-4 text-indigo-700 hover:text-red-700" />
                                </BadgePill>
                            </InertiaLink>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <FormLabel :value="$t('messages.image_name')" for="image_name" />
                    <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            v-model="form.image_name"
                            type="text"
                            :placeholder="`${$t('messages.search')}: ${$t('messages.image_name')}`"
                            class="pr-10 border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm w-full"
                        />
                        <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div v-if="meta.links.question_csv_index" class="mt-5">
            <AppButton element="a" :href="meta.links.question_csv_index">
                {{ $t('messages.download_csv') }}
            </AppButton>
        </div>

        <div
            v-if="meta.can.mass_assign_grade_levels && filters.tag_id && filters.subject_id && !form.isDirty"
            class="mt-5 flex items-center gap-2 flex-wrap"
        >
            <div>
                <AppButton element="button" type="button" @click="showGradeLevelModal = true">
                    {{ $t('messages.assign_grade_levels', { count: questions.total }) }}
                </AppButton>
                <Modal :show="showGradeLevelModal" @close="showGradeLevelModal = false">
                    <div>
                        {{ $t('messages.assign_X_questions_to_grade_levels', { count: questions.total }) }}
                    </div>

                    <form action="" @submit.prevent="assignGradeLevels" class="mt-3">
                        <div class="sm:col-span-2">
                            <div class="mt-1">
                                <FormLabel :value="$tc('messages.grade_levels', 2)" for="grade_level_id" />
                                <div class="mt-1 flex gap-2">
                                    <BadgePill
                                        v-for="gradeLevel in options.grade_levels"
                                        class="mr-1"
                                        :key="gradeLevel.value"
                                        :color="
                                            assignGradeLevelsForm.grade_level_ids.includes(gradeLevel.value)
                                                ? 'indigo'
                                                : 'gray'
                                        "
                                    >
                                        <label>
                                            <input
                                                v-model="assignGradeLevelsForm.grade_level_ids"
                                                name="grade_levels"
                                                :value="gradeLevel.value"
                                                type="checkbox"
                                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded sr-only"
                                            />
                                            {{ gradeLevel.text }}
                                        </label>
                                    </BadgePill>
                                </div>
                                <FormError :value="assignGradeLevelsForm.errors.grade_level_ids" class="mt-2" />
                            </div>
                        </div>

                        <div class="flex justify-end mt-5">
                            <SubmitFormButton
                                :button-text="$t('messages.save')"
                                :processing="assignGradeLevelsForm.processing"
                            />
                        </div>
                    </form>
                </Modal>
            </div>
            <div>
                <QuestionsMassReplaceModal
                    :questions-total="questions.total"
                    :url="meta.links.questions_replace_string_update"
                />
            </div>
        </div>

        <div v-if="questions.data.length === 0" class="flex flex-col mt-5">
            <EmptyState picture />
        </div>

        <div class="md:grid md:grid-cols-2 md:gap-6 mt-5" v-else>
            <div
                v-for="question in questions.data"
                class="rounded-lg border-2 border-gray-300 py-2 px-3 shadow-lg"
                :key="`${question.id}_${question.updated_at}`"
            >
                <QuestionBaseDisplay :question="question">
                    <div>
                        <div class="flex justify-between p-1">
                            <div class="inline-block">
                                <QuestionEditFormPanel :question="question" v-if="question.original_id === null" />
                            </div>
                            <div class="inline-block">
                                <InertiaSquareLinkButton action="show" :href="question.links.show" />
                            </div>
                        </div>
                        <div class="font-semibold text-gray-900 truncate">
                            {{ question.title }}
                        </div>
                        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.description">
                            <QuestionDescriptionDisplay :question="question" />
                        </div>
                        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.image_path">
                            <img :src="question.image_path" alt="cover" class="h-auto" />
                        </div>
                        <div class="mt-3 p-2 bg-gray-100 rounded-lg" v-if="question.shared_image">
                            <img :src="question.shared_image" alt="cover" class="h-auto" />
                        </div>
                        <div>
                            <CopyrightNotice :info="question.copyright" />
                        </div>
                        <div class="mt-3 p-2" v-if="question.graph">
                            <QuestionLineGraph :data="question.graph" v-if="question.graph.type === 'R1Did'" />
                            <GraphToolbox
                                :elements="question.graph.elements"
                                :graph="question.graph.graph"
                                v-if="question.graph.type === 'GraphToolbox'"
                            />
                            <GraphFunctionPlot
                                :elements="question.graph.elements"
                                :graph="question.graph.graph"
                                v-if="question.graph.type === 'GraphFunctionPlot'"
                            />
                        </div>

                        <HintAlert v-if="question.hint" class="mt-1">
                            <span class="font-semibold">{{ $t('messages.hint') }}:</span>
                            {{ question.hint }}
                        </HintAlert>

                        <component :is="question.type" :question="question" />
                    </div>
                    <div class="mt-1 flex flex-wrap gap-2">
                        <InertiaLink v-for="tag in question.tag_links" :key="tag.id" :href="tag.url">
                            <BadgePill>
                                {{ tag.name }}
                            </BadgePill>
                        </InertiaLink>
                    </div>
                    <div class="mt-1 flex flex-wrap gap-2">
                        <BadgePill
                            v-for="grade_level in question.grade_levels_display"
                            :key="grade_level.id"
                            color="gray"
                        >
                            {{ grade_level.name }}
                        </BadgePill>
                    </div>
                    <div v-if="question.answers_count">
                        <BadgePill color="gray">
                            {{ $tc('messages.answers', 2) }}: {{ question.answers_count }}
                        </BadgePill>
                        <div>
                            <div>
                                <ProgressBarCurrentMax
                                    v-if="question.correct_answers_count !== null"
                                    :current="question.correct_answers_count"
                                    :max="question.answers_count"
                                    color="green"
                                    background-color="red"
                                    class="mt-1 w-full"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <BadgePill color="gray">
                            {{ question.subject_name }}
                        </BadgePill>
                    </div>
                </QuestionBaseDisplay>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="questions" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import QuestionEditFormPanel from '@/components/Quiz/QuestionEditFormPanel.vue';
import HintAlert from '@/components/Quiz/HintAlert.vue';
import BadgePill from '@/components/BadgePill.vue';
import QuestionDescriptionDisplay from '@/components/Quiz/QuestionDescriptionDisplay.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import EmptyState from '@/components/EmptyState.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleXFilled } from '@tabler/icons-vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import DataListSuggestions from '@/components/Quiz/DataListSuggestions.vue';
import QuestionBaseDisplay from '@/components/Quiz/QuestionBaseDisplay.vue';
import CopyrightNotice from '@/components/CopyrightNotice.vue';
import SlideOverCheckboxInput from '@/components/Forms/SlideOverCheckboxInput.vue';
import Modal from '@/components/Modal.vue';
import QuestionLineGraph from '@/components/Quiz/QuestionLineGraph.vue';
import ProgressBarCurrentMax from '../../../components/Gamification/ProgressBarCurrentMax.vue';
import QuestionsMassReplaceModal from './partials/QuestionsMassReplaceModal.vue';
import GraphToolbox from '../../../components/Quiz/GraphToolbox.vue';
import GraphFunctionPlot from '../../../components/Quiz/GraphFunctionPlot.vue';

export default {
    components: {
        GraphFunctionPlot,
        GraphToolbox,
        QuestionsMassReplaceModal,
        ProgressBarCurrentMax,
        QuestionLineGraph,
        Modal,
        SlideOverCheckboxInput,
        CopyrightNotice,
        QuestionBaseDisplay,
        DataListSuggestions,
        SubmitFormButton,
        AppButton,
        EmptyState,
        FormError,
        FormLabel,
        FormSelect,
        QuestionDescriptionDisplay,
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
        QuestionEditFormPanel,
        HintAlert,
        BadgePill,
        IconCircleXFilled,

        // { question_view_only_component }
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'questions', 'filters', 'options', 'defaults'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
                tag_name: this.filters.tag_name,
                description: this.filters.description,
                description_no: this.filters.description_no,
                tag_id: this.filters.tag_id,
                difficulty: this.filters.difficulty,
                difficulty_in: this.filters.difficulty_in.map((d) => +d),
                subject_id: this.filters.subject_id,
                grade_level_id: this.filters.grade_level_id,
                file_collection_id: this.filters.file_collection_id,
                type: this.filters.type,
                order_by: this.filters.order_by,
                image_name: this.filters.image_name,
            }),
            assignGradeLevelsForm: this.$inertia.form({
                grade_level_ids: [],
            }),
            showGradeLevelModal: false,
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
        assignGradeLevels() {
            let values = {};
            values.search = this.form.search;
            values.tag_name = this.form.tag_name;
            values.description = this.form.description;
            values.description_no = this.form.description_no;
            values.tag_id = this.form.tag_id;
            values.difficulty = this.form.difficulty;
            values.difficulty_in = this.form.difficulty_in;
            values.subject_id = this.form.subject_id;
            values.grade_level_id = this.form.grade_level_id;
            values.file_collection_id = this.form.file_collection_id;
            values.type = this.form.type;
            this.assignGradeLevelsForm
                .transform(function (data) {
                    return { ...values, ...data };
                })
                .patch(this.meta.links.questions_grade_levels_update, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.showGradeLevelModal = false;
                    },
                });
        },
    },
};
</script>
